import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {User} from './core/models/user';
import {Customer} from './core/auth';

@Injectable()
export class TopbarService {

    private avatarSource = new Subject<User>();
    private customerSource = new Subject<Customer>();

    avatarHandler = this.avatarSource.asObservable();
    customerHandler = this.customerSource.asObservable();

    setAvatarItems(user: User) {
        this.avatarSource.next(user);
    }

    setCustomerItems(customer: Customer) {
        this.customerSource.next(customer);
    }
}
